import { Routes, Route, Navigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import "bootstrap/dist/css/bootstrap.rtl.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "react-toastify/dist/ReactToastify.css";

import LoginPage from "./components/auth/login";
import UserPanel from "./components/panel/UserPanel";
import AdminPanel from "./components/panel/AdminPanel";
import UserList from "./components/user/List";
import FactoryList from "./components/factory/List";
import Reports from "./components/reports/List";
import CompanyList from "./components/company/List";
import AddCar from "./components/car/Add";
import EditReport from "./components/reports/Edit";
import Release from "./components/reports/Release";
import SendSms from "./components/reports/SendSms";
import Album from "./components/reports/Album";
import CarPainting from "./components/reports/CarPainting";
import CarSmoothing from "./components/reports/CarSmoothing";
import Photo from "./components/reports/Photo";
import Status from "./components/reports/Status";
import Payment from "./components/reports/Payment";
import ExtraTool from "./components/reports/ExtraTool";
import AppBar from "./components/panel/AppBar";
import StatusBar from "./components/panel/StatusBar";
import WorkersList from "./components/user/workers";
import Reception from "./components/reports/Reception";
import ForgotPasswordForm from "./components/auth/ForgetPasswordForm";
import ResetPasswordForm from "./components/auth/ResetPasswordForm";
import Transaction from "./components/transaction/Transaction";
import TransactionCheck from "./components/transaction/TransactionCheck";
import Customer from "./components/reports/Customer";
import { ToastContainer } from "react-toastify";
import ProtectedRoute from "./utils/ProtectedRoute";
import AdminTransaction from "./components/transaction/AdminTransaction";
import { getMyInfo } from "./auth";
import AdminAllTransactions from "./components/transaction/AdminAllTransactions";
import RegisterPage from "./components/auth/Register";

function App() {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [hideBars, setHideBars] = useState(false);
  const [role, setRole] = useState(null);

  const isCustomerPath = window.location.pathname.includes("/c/");

  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      setAuthenticated(true);

      async function fetchData() {
        const response = await getMyInfo();
        setRole(response.data.data.role);
      }

      fetchData();
    } else {
      setAuthenticated(false);
      setRole(null);
    }
    setLoading(false);

    const location = window.location.pathname;
    setHideBars(location === "/transaction-check" || isCustomerPath);
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Routes>
        <Route path="/transaction-check" element={<TransactionCheck />} />
        <Route path="/reset-password" element={<ResetPasswordForm />} />
        <Route path="/request/c/:requestUuid" element={<Customer />} />
        <Route path="/register" element={<RegisterPage />} />
      </Routes>
      {!hideBars && authenticated && <AppBar />}
      <Routes>
        <Route
          path="/login"
          element={
            <ProtectedRoute
              element={LoginPage}
              authenticated={!authenticated}
            />
          }
        />
        <Route
          path="/"
          element={<Navigate to={authenticated ? "/user-panel" : "/login"} />}
        />
        <Route
          path="/user-panel"
          element={
            <ProtectedRoute element={UserPanel} authenticated={authenticated} />
          }
        />
        <Route
          path="/admin/transactions"
          element={
            <ProtectedRoute
              element={AdminAllTransactions}
              authenticated={authenticated}
              role={role}
              requiredRole="admin"
            />
          }
        />
        <Route
          path="/admin/transactions/:companyId"
          element={authenticated ? <AdminTransaction /> : <LoginPage />}
        />
        <Route
          path="/forgot-password"
          element={
            <ProtectedRoute
              element={ForgotPasswordForm}
              authenticated={!authenticated}
            />
          }
        />
        <Route
          path="/reset-password/:token"
          element={
            <ProtectedRoute
              element={ResetPasswordForm}
              authenticated={!authenticated}
            />
          }
        />
        <Route
          path="/add-car"
          element={
            <ProtectedRoute element={AddCar} authenticated={authenticated} />
          }
        />
        <Route
          path="/admin-panel"
          element={
            <ProtectedRoute
              element={AdminPanel}
              authenticated={authenticated}
              role={role}
              requiredRole="admin"
            />
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute
              element={UserList}
              authenticated={authenticated}
              role={role}
            />
          }
        />
        <Route
          path="/workers"
          element={
            <ProtectedRoute
              element={WorkersList}
              authenticated={authenticated}
              role={role}
            />
          }
        />
        <Route
          path="/factories"
          element={
            <ProtectedRoute
              element={FactoryList}
              authenticated={authenticated}
              role={role}
            />
          }
        />
        <Route
          path="/companies"
          element={
            <ProtectedRoute
              element={CompanyList}
              authenticated={authenticated}
              role={role}
              requiredRole="admin"
            />
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute
              element={Reports}
              authenticated={authenticated}
              role={role}
            />
          }
        />
        <Route
          path="/request/:requestId/edit/:carId"
          element={
            <ProtectedRoute
              element={EditReport}
              authenticated={authenticated}
            />
          }
        />
        <Route
          path="/send-sms/:reportId"
          element={
            <ProtectedRoute element={SendSms} authenticated={authenticated} />
          }
        />
        <Route
          path="/album/:reportId"
          element={
            <ProtectedRoute element={Album} authenticated={authenticated} />
          }
        />
        <Route
          path="/car/:carId/painting/:requestId"
          element={
            <ProtectedRoute
              element={CarPainting}
              authenticated={authenticated}
            />
          }
        />
        <Route
          path="/car/:carId/smoothing/:requestId"
          element={
            <ProtectedRoute
              element={CarSmoothing}
              authenticated={authenticated}
            />
          }
        />
        <Route
          path="/car/:carId/reception/:requestId"
          element={
            <ProtectedRoute element={Reception} authenticated={authenticated} />
          }
        />
        <Route
          path="/car/:carId/photo/:requestId"
          element={
            <ProtectedRoute element={Photo} authenticated={authenticated} />
          }
        />
        <Route
          path="/car/:carId/status/:requestId"
          element={
            <ProtectedRoute element={Status} authenticated={authenticated} />
          }
        />
        <Route
          path="/request/:requestId/payment/:carId"
          element={
            <ProtectedRoute element={Payment} authenticated={authenticated} />
          }
        />
        <Route
          path="/request/:requestId/extra-tool/:carId"
          element={authenticated ? <ExtraTool /> : <LoginPage />}
        />
        <Route
          path="/request/:requestId/release/:carId"
          element={authenticated ? <Release /> : <LoginPage />}
        />
        <Route
          path="/transactions"
          element={authenticated ? <Transaction /> : <LoginPage />}
        />
      </Routes>
      {!hideBars && authenticated && <StatusBar />}
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        limit={1}
      />
    </>
  );
}

export default App;
